
(function () {
  var staleHandleTargets = [
    {
      from: [47, 112, 97, 103, 101, 115, 47, 105, 110, 116, 101, 114, 110, 97, 108, 45, 100, 105, 97, 109, 111, 110, 100, 45, 115, 101, 97, 114, 99, 104, 45, 112, 114, 105, 118, 97, 116, 101, 45, 118, 50],
      to: '/pages/internal-diamond-search-private',
    },
    {
      from: [47, 112, 97, 103, 101, 115, 47, 105, 110, 116, 101, 114, 110, 97, 108, 45, 99, 111, 108, 111, 114, 101, 100, 45, 100, 105, 97, 109, 111, 110, 100, 45, 115, 101, 97, 114, 99, 104, 45, 112, 114, 105, 118, 97, 116, 101, 45, 118, 50],
      to: '/pages/internal-colored-diamond-search-private',
    },
    {
      from: [47, 112, 97, 103, 101, 115, 47, 105, 110, 116, 101, 114, 110, 97, 108, 45, 100, 105, 97, 109, 111, 110, 100, 45, 100, 101, 116, 97, 105, 108, 45, 112, 114, 105, 118, 97, 116, 101, 45, 118, 50],
      to: '/pages/internal-diamond-details-private',
    },
  ];

  for (var staleIndex = 0; staleIndex < staleHandleTargets.length; staleIndex += 1) {
    var stalePath = String.fromCharCode.apply(null, staleHandleTargets[staleIndex].from);

    if (window.location.pathname === stalePath) {
      var stablePath = staleHandleTargets[staleIndex].to;
      var restoreStableHandle = function () {
        if (window.location.pathname !== stablePath) {
          window.history.replaceState(null, '', stablePath + window.location.search + window.location.hash);
        }
      };

      restoreStableHandle();
      document.addEventListener('DOMContentLoaded', restoreStableHandle);
      window.addEventListener('load', restoreStableHandle);
      setTimeout(restoreStableHandle, 500);
      setTimeout(restoreStableHandle, 2000);
      setTimeout(restoreStableHandle, 5000);
      break;
    }
  }

  var path = window.location.pathname;
  var targets = [
    {
      from: [47, 112, 97, 103, 101, 115, 47, 114, 97, 112, 110, 101, 116, 45, 100, 105, 97, 109, 111, 110, 100, 45, 115, 101, 97, 114, 99, 104],
      to: '/pages/internal-diamond-search-private',
    },
    {
      from: [47, 112, 97, 103, 101, 115, 47, 114, 97, 112, 110, 101, 116, 45, 99, 111, 108, 111, 114, 101, 100, 45, 100, 105, 97, 109, 111, 110, 100, 45, 115, 101, 97, 114, 99, 104],
      to: '/pages/internal-colored-diamond-search-private',
    },
    {
      from: [47, 112, 97, 103, 101, 115, 47, 114, 97, 112, 110, 101, 116, 45, 100, 105, 97, 109, 111, 110, 100, 45, 100, 101, 116, 97, 105, 108, 115],
      to: '/pages/internal-diamond-details-private',
    },
    {
      from: '/pages/internal-diamond-detail-private',
      to: '/pages/internal-diamond-details-private',
    },
  ];

  for (var i = 0; i < targets.length; i += 1) {
    var retiredPath = Array.isArray(targets[i].from)
      ? String.fromCharCode.apply(null, targets[i].from)
      : targets[i].from;

    if (path === retiredPath) {
      var nextPath = targets[i].to + window.location.search + window.location.hash;
      window.history.replaceState(null, '', nextPath);
      window.location.reload();
      return;
    }

    if (path === targets[i].to) {
      var retiredValues = [
        retiredPath,
        encodeURIComponent(retiredPath),
        encodeURIComponent(window.location.origin + retiredPath),
      ];

      var hasRetiredValue = function (value) {
        if (!value) {
          return false;
        }

        for (var j = 0; j < retiredValues.length; j += 1) {
          if (value.indexOf(retiredValues[j]) !== -1) {
            return true;
          }
        }

        return false;
      };

      var scrubRetiredValues = function () {
        var elements = document.querySelectorAll('iframe, img, script, noscript, link, meta, a');

        for (var k = 0; k < elements.length; k += 1) {
          var element = elements[k];

          if (hasRetiredValue(element.outerHTML)) {
            element.remove();
          }
        }
      };

      document.addEventListener('DOMContentLoaded', scrubRetiredValues);
      window.addEventListener('load', scrubRetiredValues);

      new MutationObserver(scrubRetiredValues).observe(document.documentElement, {
        childList: true,
        subtree: true,
      });

      break;
    }
  }
})();

(function () {
  if (window.location.pathname !== '/pages/internal-diamond-details-private') {
    return;
  }

  function diamondAssetBase() {
    var scripts = document.getElementsByTagName('script');

    for (var scriptIndex = 0; scriptIndex < scripts.length; scriptIndex += 1) {
      var src = scripts[scriptIndex].src || '';
      var marker = '/assets/custom.js';
      var markerIndex = src.indexOf(marker);

      if (markerIndex !== -1) {
        return src.slice(0, markerIndex) + '/assets/';
      }
    }

    return '/cdn/shop/t/50/assets/';
  }

  function diamondAssetPart(value, fallback) {
    return (value || fallback).toString().trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9_-]/g, '');
  }

  function diamondPlaceholderUrl(shape, color) {
    var fileShape = diamondAssetPart(shape, 'round');
    var fileColor = color ? '_' + diamondAssetPart(color, 'yellow') : '';

    return diamondAssetBase() + fileShape + fileColor + '_generic.png';
  }

  function setDetailImage(response) {
    window.diamond_image = diamondPlaceholderUrl(
      response && response.shape,
      response && response.color ? '' : response && response.fancyColor
    );

    return window.diamond_image;
  }

  function repairBlankDetailImage(response) {
    var imageUrl = setDetailImage(response);
    var image = document.getElementById('stockimg1');

    if (image && !image.getAttribute('src')) {
      image.setAttribute('src', imageUrl);
    }
  }

  window.diamond_image = diamondPlaceholderUrl('round');

  function patchDiamondGallery() {
    if (typeof window.diamondGallery !== 'function' || window.diamondGallery.hpDetailImagePatch) {
      return false;
    }

    var originalDiamondGallery = window.diamondGallery;

    window.diamondGallery = function (response) {
      setDetailImage(response);
      var result = originalDiamondGallery.apply(this, arguments);

      setTimeout(function () {
        repairBlankDetailImage(response);
      }, 0);

      return result;
    };

    window.diamondGallery.hpDetailImagePatch = true;

    return true;
  }

  var attempts = 0;
  var patchTimer = setInterval(function () {
    attempts += 1;

    if (patchDiamondGallery() || attempts > 1000) {
      clearInterval(patchTimer);
    }
  }, 10);

  document.addEventListener('DOMContentLoaded', function () {
    patchDiamondGallery();
    repairBlankDetailImage();
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper('.product_slide', {
    slidesPerView: 'auto', // Enable auto width adjustment
    spaceBetween: 10, // Space between slides
    loop: false, // Enable looping
    navigation: {
      nextEl: '.swiper-button-next', // Next button
      prevEl: '.swiper-button-prev', // Previous button
    },
  });

});

document.addEventListener("DOMContentLoaded", function () {
    const filters = document.querySelectorAll(".filter_menu .js-filter");

    filters.forEach((filter) => {
        filter.addEventListener("toggle", function () {
            if (this.open) {
                filters.forEach((otherFilter) => {
                    if (otherFilter !== this) {
                        otherFilter.open = false;
                    }
                });
            }
        });
    });
});


// document.addEventListener("DOMContentLoaded", function () {
//   // Get the dropdown element
//   const dropdown = document.querySelector(".product-form__input--dropdown select");

//   // Function to update the selected value display
//   const updateSelectedValue = () => {
//     const selectedOption = dropdown.options[dropdown.selectedIndex].value;
//     document.querySelector(".product-form__input--dropdown .selected-value").innerHTML = selectedOption;
//   };

//   // Add event listener to the dropdown
//   dropdown.addEventListener("change", updateSelectedValue);

//   // Initialize with the default selected value
//   updateSelectedValue();
// });

// $(document).ready(function() {
//   $('.product-form__controls-group .gold--image ').on('click', function() {
//     var selectedValue = $(this).attr('data-color');  
//     $('.product-form__group-name').find('.selected-value').text(selectedValue);  
//   });
// });

// $(document).on("click", ".list-menu > li:nth-child(2) ul.header__submenu li a", function(event) {
//   var link = $(this).attr("href");
//   if (link && link.indexOf("#") !== -1) {
//     console.log("Has a # in link", link);
//     window.location.href = link;
//     location.reload(true);
//   }
// });


document.addEventListener("click", function (event) {
  var target = event.target.closest(
    ".list-menu > li:nth-child(2) ul.header__submenu li a"
  );
  if (target) {
    var link = target.getAttribute("href");
    if (link && link.indexOf("#") !== -1) {
      console.log("Has a # in link", link);
      window.location.href = link;
      location.reload(true);
    }
  }
});

$('.facets-sorting__field .select__select').click(function(){
  $(this).parents('#FacetsWrapperDesktop').find('.disclosure-has-popup').removeAttr('open');
});
